import {
  ExcessDeductibleLocal,
  SumInsuredLocal,
} from '../../@types/RunPetisSimulation'
import { currencyFormatter } from '../../utils/currencyFormatter'

const CODES = {
  FV: 'FV',
  VV: 'VV',
  CT: 'CT',
} as const

export function getExcessDeductibleTextToDisplay(
  excessDeductible: ExcessDeductibleLocal,
) {
  if (excessDeductible?.excessTypeCode === CODES.FV) {
    return excessDeductible.excessMinValue?.toString()
  }

  if (excessDeductible?.excessTypeCode === CODES.VV) {
    if (
      (excessDeductible?.excessMinPercent ?? 0) === 0 ||
      (excessDeductible?.excessMaxPercent ?? 0) === 0
    ) {
      return `${currencyFormatter(Number(excessDeductible.excessMinValue))}€`
    }

    // TODO: CHECK MIN/MAX percentage
    return `${excessDeductible.excessMinPercent}%
        ${
          excessDeductible.excessMinValue === excessDeductible.excessMaxValue
            ? `(min ${currencyFormatter(
                Number(excessDeductible.excessMinValue),
              )}€)`
            : `(min ${currencyFormatter(
                Number(excessDeductible.excessMinValue),
              )}€ e max ${currencyFormatter(
                Number(excessDeductible.excessMaxValue),
              )}€)`
        }
      `
  }

  return ''
}

export function getSumInsuredTextToDisplay(sumInsured: SumInsuredLocal) {
  if (sumInsured?.sumInsuredTypeCode === CODES.CT) {
    return sumInsured.capitalTiers?.find((capitalTier) => capitalTier.isDefault)
      ?.valueDescription
  }

  if (
    sumInsured?.sumInsuredTypeCode === CODES.FV ||
    sumInsured?.sumInsuredTypeCode === CODES.VV
  ) {
    if ((sumInsured.minValue ?? 0) === 0 || (sumInsured.maxValue ?? 0) === 0) {
      return ''
    }

    if (sumInsured?.minValue === sumInsured?.maxValue) {
      return `${currencyFormatter(Number(sumInsured.minValue))}€`
    } else {
      return `${currencyFormatter(
        Number(sumInsured.minValue),
      )}€ - ${currencyFormatter(Number(sumInsured.maxValue))}€`
    }
  }

  return ''
}
